import React, { useEffect, useState } from "react";
import InternRequestTable from "../../Components/InternRequestTable";
import { matchOptions } from "../../utils/function";
import { optionsBranch } from "../../data/branch-data";
import { Container } from "@mui/material";
import { Grid } from "@mui/material";

import { internType } from "../../data/interntype-data";

const DashboardInternshipActiveTab = ({
  items = [],
  allStaff = [],
  textActive,
}) => {
  const [rowsData, setRowsData] = useState([]);

  const onHandleItems = (items) => {
    const rows = items.map((row) => {
      let dataJson;

      if (row.internLocation) {
        dataJson = JSON.parse(row?.internLocation?.manual_data);
      }

      return {
        req_id: row?.req_id,
        st_id: row?.st_id,
        name: `${row?.internStudent?.name}, ${matchOptions(
          optionsBranch,
          row?.internStudent?.b_id
        )}`,
        company: row?.company?.name,
        address: `${row.company.address} ${row.company.subdistrict}
        ${row.company.district} ${row.company.province}
        ${row.company.zip}`,
        type_internship: matchOptions(internType, row.type_internship),
        intern_period: `${row.start_date} ถึง ${row.end_date}`,
        status: new Date(row?.start_date).getTime(),
        supervisor: row.supervisor,

        updated_at: "",
        form: row?.internLocation?.date_updated ?? "",
        internLocation_created: row?.internLocation?.date_created ?? "",
        start_date: row.start_date,
        end_date: row.end_date,
        b_id: row?.internStudent?.b_id,

        addressIntern: dataJson
          ? `${dataJson?.company.address.no} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "แขวง"
                : "ต."
            }` +
            `${dataJson?.company.address.sub_district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? "เขต"
                : "อ."
            }` +
            `${dataJson?.company.address.district} ${
              dataJson?.company.address.province.includes("กรุงเทพ")
                ? " "
                : "จ."
            }${dataJson?.company.address.province}` +
            ` ${dataJson?.company.address.postcode}`
          : `${row.company.address} ${
              row.company.province.includes("กรุงเทพ") ? "แขวง" : "ต."
            }` +
            `${row.company.subdistrict} ${
              row.company.province.includes("กรุงเทพ") ? "เขต" : "อ."
            }${row.company.district}` +
            ` ${row.company.province.includes("กรุงเทพ") ? "" : "จ."}${
              row.company.province
            } ${row.company.zip}`,

        addressUrl: dataJson?.location.link ?? "",
        internDetailMark: rows?.internLocation?.mark ?? "",

        logbooklist: row?.doclogbook ?? "",
        internReport: row?.internReport,
      };
    });

    const sortData = rows.sort((a, b) => (a.company > b.company ? 1 : -1));
    console.log("sortData", sortData);
    return sortData;
  };

  useEffect(() => {
    if (items.length) {
      const handleItem = onHandleItems(items);
      setRowsData(handleItem);
    }
  }, [items]);

  const headCells = [
    {
      id: "order",
      numeric: true,
      disablePadding: false,
      label: "#",
    },

    {
      id: "req_id",
      numeric: true,
      disablePadding: false,
      label: "Request ID	",
    },

    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "ชื่อ - สกุล	",
    },

    {
      id: "company",
      numeric: false,
      disablePadding: false,
      label: "สถานประกอบการ",
    },
    {
      id: "supervisor",
      numeric: false,
      disablePadding: false,
      label: "อาจารย์นิเทศ",
    },

    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "สถานะ",
    },
    {
      id: "form",
      numeric: false,
      disablePadding: false,
      label: "ฟอร์ม",
    },
  ];

  return (
    <>
        
        <InternRequestTable
          tableColumn={headCells}
          tableData={rowsData}
          allStaff={allStaff}
          textActive={textActive}
        />
        
    
    </>
  );
};

export default DashboardInternshipActiveTab;
